module.exports = __webpack_public_path__ + "img/ex.d752aad9.png";